export const ModalChangePhoneNumberTranslationsCs = {
  changePhoneNumber: 'Změnit telefonní číslo',
  phoneNumber: 'Telefonní číslo',
  saveButton: 'Uložit',
};
